<div class="header-wrap">
    <div class="search-bar">
        <form>
            <div class="input-row input-row-wide header-select-wrap">
                <div class="input-wrap">
                    <div class="dropdown-wrap">
                        <app-form-select-box [options]="searchArray" [dropDownIdKey]="'id'" [dropdownLabel]="'name'" [id]="'headerSearch'" [formElementName]="headerSearch" [controlName]="'search'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                        </app-form-select-box>
                    </div>
                </div>
            </div>
            <!-- <span class="search-icon">
                <img src="assets/images/search-icon.svg" alt="search"></span>
            <input type="text" value="" placeholder="Search here" class="form-control"> -->
        </form>
    </div>

    <div class="header-right">
        <span class="order-name">{{globalService['orderName']?globalService['orderName']:''}}</span>
        <!-- <ul class="preferences">
            <li>CDN <img src="assets/images/info-icon.svg" alt="info-icon"></li>
            <li>LNH <img src="assets/images/info-icon.svg" alt="info-icon"></li>
        </ul> -->
        <ul class="profile-details">
            <li>
                <img class="notification-icon" src="assets/images/notification.svg" alt="notification" (click)="forPopupOpen('notification')">
                <span class="notification-dot" *ngIf="!globalService['isAllRead']"></span>
                <app-notification *ngIf="cardType && (globalService.showPopUp==cardType['notification'])">

                </app-notification>
                <app-add-new-alert *ngIf="cardType && (globalService.showPopUp==cardType['AddNewAlert'])">
                </app-add-new-alert>
                <app-view-alerts *ngIf="cardType && (globalService.showPopUp==cardType['viewAlert'])"></app-view-alerts>
                <app-edit-alert *ngIf="cardType && (globalService.showPopUp==cardType['editAlert'])"></app-edit-alert>
                <app-edit-profile *ngIf="cardType && (globalService.showPopUp==cardType['editProfile'])">
                </app-edit-profile>
                <app-change-password *ngIf="cardType && (globalService.showPopUp==cardType['changePassword'])">
                </app-change-password>
            </li>
            <li class="export-data">
                <img src="assets/images/share.svg" alt="export" id="share" class="notification-icon" [ngClass]="{'active':sharePopup}" (click)="sharePopup= !sharePopup;">
                <div class="export-list" [ngClass]="{'d-none':!sharePopup}">
                    <!-- <a href="javascript:void(0)" class="export-link" (click)="openSubPopUp('downloadPopup');" [ngClass]="{'active':subPopUp== 'downloadPopup'}"> -->
                    <a href="javascript:void(0)" class="export-link" (click)="downloadAsPDF($event)">
                        <span class="export-icons pdf-icon"></span>
                        <!-- <span class="export-text" [ngClass]="{'active':subPopUp== 'downloadPopup'}"> Download</span> -->
                        <span class="export-text"> Download</span>
                        <!-- <span class="export-arrows"></span> -->
                        <!-- <div class="export-sub-list" *ngIf="subPopUp== 'downloadPopup'">
                            <a href="javascript:void(0)" class="export-link" (click)="downloadCSV($event)">
                                <span class="export-icons csv-icon"></span>
                                <span class="export-text">CSV</span>
                            </a>
                            <a href="javascript:void(0)" (click)="downloadAsPDF($event)" class="export-link">
                                <span class="export-icons pdf-icon"></span>
                                <span class="export-text">PDF</span>
                            </a>
                        </div> -->
                    </a>

                    <!-- <a href="javascript:void(0)" class="export-link" > -->
                        <!-- <span class="export-icons slack-icon"></span> -->
                        <!-- <span class="export-text" [ngClass]="{'active':subPopUp== 'shareButtonPopup'}">Share</span> -->
                        <!-- <span class="export-text">Slack</span> -->
                        <!-- <span class="export-arrows"></span>
                        <div class="export-sub-list" *ngIf="subPopUp== 'shareButtonPopup'">
                            <a href="javascript:void(0)" class="export-link">
                                <span class="export-icons slack-icon"></span>
                                <span class="export-text">Slack</span>
                            </a>
                            <a href="javascript:void(0)" class="export-link">
                                <span class="export-icons email-icon"></span>
                                <span class="export-text">Email</span>
                            </a>
                        </div> -->
                    <!-- </a> -->
                    <!-- <a href="javascript:void(0)" class="export-link"> -->
                        <!-- <span class="export-icons email-icon"></span> -->
                        <!-- <span class="export-text" [ngClass]="{'active':subPopUp== 'shareButtonPopup'}">Share</span> -->
                        <!-- <span class="export-text">Email</span> -->
                        <!-- <span class="export-arrows"></span>
                        <div class="export-sub-list" *ngIf="subPopUp== 'shareButtonPopup'">
                            <a href="javascript:void(0)" class="export-link">
                                <span class="export-icons slack-icon"></span>
                                <span class="export-text">Slack</span>
                            </a>
                            <a href="javascript:void(0)" class="export-link">
                                <span class="export-icons email-icon"></span>
                                <span class="export-text">Email</span>
                            </a>
                        </div> -->
                    <!-- </a> -->
                </div>
            </li>
            <li class=" profile-wrapper ">
                <span class="profile-img"><img src="assets/images/defaultProfile.png" alt="profile"></span>
                <div class="about-profile" id="about-profile" [ngClass]="{'active':profilePopup}" (click)="profilePopup= !profilePopup;">
                    <span class="profile-name">{{globalService.userDetails['firstName'] && globalService.userDetails['lastName']?globalService.userDetails['firstName'] +'  '+globalService.userDetails['lastName']:'-'}}</span>
                    <span class="profile-designation">{{globalService && globalService.userDetails && globalService.userDetails['designation']?globalService.userDetails['designation']:'-'}}</span>
                </div>
                <div class="profile-drop" [ngClass]="{'d-none':!profilePopup}">
                    <span class="user-detail">
                        <span>{{globalService.userDetails['email'] ?globalService.userDetails['email'] :'-'}}</span>
                    <span>{{globalService.userDetails['mobile'] ?globalService.userDetails['mobile'] :'-'}}</span>
                    </span>

                    <a href="javascript:void(0)" class="edit-profile-link" (click)="forPopupOpen('editProfile')">
                        <img src="assets/images/user-icon.svg" alt="">Edit Profile</a>
                    <a href="javascript:void(0)" class="sign-out-link" (click)="onSignOut()"><img src="assets/images/sign-out.svg" alt="">Sign out</a>
                </div>
            </li>
        </ul>
    </div>
</div>
<div class="alert-error" *ngIf="errorMessage">{{errorMessage}}</div>
<div class="alert-success" *ngIf="successMessage">{{successMessage}}</div>
<div class="alert-warning" *ngIf="warningMessage">{{warningMessage}}</div>
<!-- edit-profile popup -->

<!-- change password popup -->

<!-- alert-notification popup (on notification bell icon of profile) -->
<!-- <div class="popup-bg d-none">
    <div class="popup alert-notification">
        <div class="popup-content">
            <div class="popup-content-head">
                <h3>Alert Notification</h3>
                <div class="popup-head-links">
                    <a href="javscript:void(0)" class="btn btn-dark">Add new alerts</a>
                    <a href="javscript:void(0)" class="btn btn-dark">View Alerts</a>
                </div>
            </div>
            <ng-scrollbar>
                <div class="popup-tabling">
                    <table class="alert-table">
                        <tr>
                            <th><span class="app-text">Name</span></th>
                            <th><span class="app-text">KPI</span></th>
                            <th><span class="app-text">Value</span></th>
                            <th><span class="app-text">App</span></th>
                            <th><span class="app-text">Network</span></th>
                            <th><span class="app-text">Time</span></th>
                            <th><span class="app-text">Date</span></th>
                            <th><span class="app-text">City</span></th>
                        </tr>
                        <tr>
                            <td><a href="javascript:void(0)" class="link-light">alert01</a></td>
                            <td><span class="app-text">AQI</span></td>
                            <td><span class="app-text">2.4</span></td>
                            <td><span class="app-text">Hotstar</span></td>
                            <td><span class="app-text">Vodafone</span></td>
                            <td><span class="app-text">12:34 pm</span></td>
                            <td><span class="app-text">01 Sept 2019</span></td>
                            <td><span class="app-text">Bangalore</span></td>
                        </tr>
                        <tr>
                            <td><a href="javascript:void(0)" class="link-light">alert02</a></td>
                            <td><span class="app-text">AQI</span></td>
                            <td><span class="app-text">2.4</span></td>
                            <td><span class="app-text">Hotstar</span></td>
                            <td><span class="app-text">Jio</span></td>
                            <td><span class="app-text">12:34 pm</span></td>
                            <td><span class="app-text">01 Sept 2019</span></td>
                            <td><span class="app-text">Lucknow</span></td>
                        </tr>
                        <tr>
                            <td><a href="javascript:void(0)" class="link-light">alert03</a></td>
                            <td><span class="app-text">AQI</span></td>
                            <td><span class="app-text">2.4</span></td>
                            <td><span class="app-text">Hotstar</span></td>
                            <td><span class="app-text">Airtel</span></td>
                            <td><span class="app-text">12:34 pm</span></td>
                            <td><span class="app-text">01 Sept 2019</span></td>
                            <td><span class="app-text">Bangalore</span></td>
                        </tr>
                        <tr>
                            <td><a href="javascript:void(0)" class="link-light">alert04</a></td>
                            <td><span class="app-text">AQI</span></td>
                            <td><span class="app-text">2.4</span></td>
                            <td><span class="app-text">Hotstar</span></td>
                            <td><span class="app-text">Vodafone</span></td>
                            <td><span class="app-text">12:34 pm</span></td>
                            <td><span class="app-text">01 Sept 2019</span></td>
                            <td><span class="app-text">New Delhi</span></td>
                        </tr>
                    </table>
                </div>
            </ng-scrollbar>
            <div class="popup-links text-right">
                <a href="javscript:void(0)" class="btn btn-light">close</a>
            </div>
        </div>
    </div>
</div> -->